import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';

const routes: Routes = [
  {
    path: 'results/keyword',
    loadChildren: () => import('./pages/results-page/results-page.module').then(m => m.ResultsPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'result',
    loadChildren: () => import('./pages/results-page/results-page.module').then(m => m.ResultsPageModule),
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login-page/login-page.module').then(m => m.LoginPageModule)
  },
  {
    path: '',
    loadChildren: () => import('./pages/home-page/home-page.module').then(m => m.HomePageModule)
  },
  {
    path: '**',
    loadChildren: () => import('./pages/home-page/home-page.module').then(m => m.HomePageModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
